import { Paper } from "@mui/material";
import { ProjectDetailDto, ProjectDto } from "../../../api/psc";
import ProjectDetailSms from "../Shared/ProjectDetailSms";

export default function ProjectDetailDesktopSms(props: {
    projects: ProjectDto[] | ProjectDetailDto[];
    onSent?: () => void;
}) {
    return (
        <Paper sx={{ p: 2 }}>
            <ProjectDetailSms projects={props.projects} />
        </Paper>
    );
}
